<template>
    <div>
        <config-main-title>Configurações {{ is_laudos ? 'de Laudos' : 'do Consultório' }}</config-main-title>

        <div class="alert alert-info">
            Essas configurações são específicas para esse computador/navegador.
        </div>

        <template v-if="!is_laudos">

            <az-input
                type="checkbox-group"
                label="Iniciar o atendimento ao chamar"
                v-model="config.iniciar_ao_chamar" />

            <az-input
                type="checkbox-group"
                label="Não exibir confirmação ao finalizar atendimento"
                v-model="config.nao_confirmar_ao_finalizar" />

        </template>

        <az-input
            type="checkbox-group"
            label="Abrir visualizador de imagens do pacs automaticamente"
            v-model="config.abrir_imagem_pacs_laudo" />
        
        <az-input
            type="checkbox-group"
            label="Utilizar 'host publico' ao obter URL de visualizador de imagens do PACs Carestream"
            v-model="config.host_publico_visualizador_imagem_pacs" />

        <nav class="navbar fixed-bottom navbar-light bg-light">
            <div>
                <button type="button" class="btn btn-success mr-1" @click="atualizar()">Atualizar</button>
                <button type="button" class="btn btn-secondary" @click="voltar()">Retornar</button>
            </div>
        </nav>

    </div>
</template>

<script>
import ConfigMainTitle from '../../cadastros/shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';

export default {
    data() { 
        return { 
            config: { 
                nao_confirmar_ao_finalizar: null, 
                iniciar_ao_chamar: null,
                host_publico_visualizador_imagem_pacs: null
            },
        }
    },

    components: { 
        ConfigMainTitle, 
        AzInput, 
    },

    computed: { 
        is_laudos: function() { 
            return this.$route && ( this.$route.path == '/laudos/config' );
        }
    },

    methods: { 
        atualizar () { 
            this.$util.setCookie(
                'cn-iac', 
                this.config.iniciar_ao_chamar ? 'S' : 'N',
                this.config.iniciar_ao_chamar ? 365 * 5 : 1, 
            );

            this.$util.setCookie(
                'cn-ncf', 
                this.config.nao_confirmar_ao_finalizar ? 'S' : 'N',
                this.config.nao_confirmar_ao_finalizar ? 365 * 5 : 1, 
            );

            this.$util.setCookie(
                'cn-aipl', 
                this.config.abrir_imagem_pacs_laudo ? 'S' : 'N',
                this.config.abrir_imagem_pacs_laudo ? 365 * 5 : 1, 
            );

            this.$util.setCookie(
                'cn-hpvip', 
                this.config.host_publico_visualizador_imagem_pacs ? 'S' : 'N',
                this.config.host_publico_visualizador_imagem_pacs ? 365 * 5 : 1, 
            );

            this.$router.go(-1);
        },

        voltar() { 
            this.$router.go(-1);
        },
    },

    beforeMount() {
        this.config.iniciar_ao_chamar = this.$util.getCookie('cn-iac') == 'S' ? true : false; 
        this.config.nao_confirmar_ao_finalizar = this.$util.getCookie('cn-ncf') == 'S' ? true : false; 
        this.config.abrir_imagem_pacs_laudo = this.$util.getCookie('cn-aipl') == 'S' ? true : false; 
        this.config.host_publico_visualizador_imagem_pacs = this.$util.getCookie('cn-hpvip') == 'S' ? true : false; 
    },

    mounted() { 
        if ( this.is_laudos ) { 
            this.$store.commit("setBreadcrumb", [
                { name: "Laudos", path: "/laudos/lista" },
                { name: "Configurações", path: "/laudos/config" }
            ]);
        } else { 
            this.$store.commit("setBreadcrumb", [
                { name: "Consultório", path: "/consultorio" },
                { name: "Configurações", path: "/consultorio/config" }
            ]);
        }

        //so vai aparecer se for carestream
    },

}
</script>
